interface IFileDownloadHelper {
  file: Blob;
  fileName: string;
}

export const fileDownloadHelper = (fileObj: IFileDownloadHelper): void => {
  const { file, fileName } = fileObj;
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  Object.assign(a, { href: url, download: fileName });
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const generateFileFromBlob = (downloadData: IFileDownloadHelper) => {
  const { file, fileName } = downloadData;
  const windowNavi: any = window.navigator;
  const ua = window.navigator.userAgent;
  const msie = ua.includes('MSIE ') || ua.includes('Trident/');

  let isMozilla = false;
  if (window.navigator.userAgent.toLowerCase().includes('firefox')) {
    isMozilla = true;
  }
  try {
    if (msie) {
      windowNavi.msSaveBlob(file, fileName);
    } else {
      if (isMozilla) {
        const fileData = new File([file], fileName, { type: 'application/force-download' });
        window.open(URL.createObjectURL(fileData));
      } else {
        const fileURL = window.URL.createObjectURL(file);
        const downloadLink = window.document.createElement('a');
        downloadLink.href = fileURL;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(fileURL);
      }
    }
  } catch (e) {
    console.error(e);
  }
};
